import { HttpClient } from '@angular/common/http';
import { Component, OnInit, NgZone } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

// const apiurl = 'https://192.168.10.105:8090/api/';
const apiurl = 'https://comments.mediasourceinc.com/api/';

@Component({
  selector: 'app-hbook',
  templateUrl: './hbook.component.html',
  styleUrls: ['./hbook.component.css']
})
export class HbookComponent implements OnInit {

  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    public router: Router,
    public ngZone: NgZone,
  ) { }

  comments = [];
  type = 'All';
  count = 0;
  countInPage = 12;
  pageList = [];
  page = 1;
  pageShowList = [];
  showTotalPageCount;
  ngOnInit() {
    let password = localStorage.getItem('password');
    if (password != 'MSIcommentboard%140!') {
      this.ngZone.run(() => this.router.navigate(['login']));
    } else {
      this.getCountAndComments('All', 1);
    }
  }

  async getCountAndComments(type, page) {
    await this.spinner.show();
    this.type = type;
    var countSQL = type == 'All' ? 'where=ORDER BY id DESC LIMIT 1' : 'where=WHERE state="' + type + '" ORDER BY id DESC LIMIT 1';
    var countResult = await this.http.post(apiurl + 'get-count-hbook', countSQL, { 'headers': { 'content-type': 'application/x-www-form-urlencoded' } }).toPromise();
    if (countResult['result']) {
      this.count = countResult['data'][0]['COUNT(id)'];
      this.pageList = [];
      this.pageShowList = [];
      for (let i = 0; i < this.count / this.countInPage; i++) {
        this.pageList.push(i + 1);
        if (i < 6) {
          this.pageShowList.push(i + 1);
        }
      }
    }

    switch (page) {
      case 'first':
        this.page = 1;
        break;
      case 'previous':
        this.page = this.page > 1 ? this.page - 1 : 1;
        break;
      case 'next':
        this.page = this.page < this.pageList.length ? this.page + 1 : this.pageList.length;
        break;
      case 'last':
        this.page = this.pageList.length;
        break;
      default:
        this.page = page;
        break;
    }

    if (this.pageList.length > 7) {
      this.showTotalPageCount = this.page < this.pageList.length - 3;
      if (this.page > 3 && this.page < this.pageList.length - 2) {
        this.pageShowList = [this.page - 3, this.page - 2, this.page - 1, this.page, this.page + 1, this.page + 2];
      } else if (this.page == this.pageList.length - 2) {
        this.pageShowList = [this.page - 4, this.page - 3, this.page - 2, this.page - 1, this.page, this.page + 1];
      } else if (this.page == this.pageList.length - 1) {
        this.pageShowList = [this.page - 5, this.page - 4, this.page - 3, this.page - 2, this.page - 1, this.page];
      } else if (this.page == this.pageList.length) {
        this.pageShowList = [this.page - 6, this.page - 5, this.page - 4, this.page - 3, this.page - 2, this.page - 1];
      }
    }

    let commentSQL = type == 'All' ? 'where=ORDER BY id DESC LIMIT ' + (this.page - 1) * this.countInPage + ',' + this.countInPage
      : 'where=WHERE state="' + type + '" ORDER BY id DESC LIMIT ' + (this.page - 1) * this.countInPage + ',' + this.countInPage
    var result = await this.http.post(apiurl + 'get-comments-hbook', commentSQL, { 'headers': { 'content-type': 'application/x-www-form-urlencoded' } }).toPromise();
    if (result['result']) {
      this.comments = result['data'];
    }
    await this.spinner.hide();
  }

  async updateComment(i, state, isBatch) {
    await this.spinner.show();
    let set = '';
    switch (state) {
      case 'delete':
        if (this.comments[i].state == 'pending') {
          set = 'state=deleted&commentId=' + this.comments[i].commentId;
        } else if ((this.comments[i].state == 'deleted' || this.comments[i].state == 'placeholder') && !isBatch) {
          set = 'state=pending&commentId=' + this.comments[i].commentId;
        } else if (this.comments[i].state == 'approved') {
          set = 'state=placeholder&commentId=' + this.comments[i].commentId;
        } else if (this.comments[i].state == 'spammed') {
          set = 'state=deleted&commentId=' + this.comments[i].commentId;
        }
        break;
      case 'publish':
        if (this.comments[i].state == 'pending') {
          set = 'state=approved&commentId=' + this.comments[i].commentId;
        } else if (this.comments[i].state == 'approved' && !isBatch) {
          set = 'state=pending&commentId=' + this.comments[i].commentId;
        } else if ((this.comments[i].state == 'deleted' || this.comments[i].state == 'placeholder') && !isBatch) {
          set = 'state=approved&commentId=' + this.comments[i].commentId;
        } else if (this.comments[i].state == 'spammed') {
          set = 'state=approved&commentId=' + this.comments[i].commentId;
        }
        break;
      case 'spam':
        if (this.comments[i].state == 'spammed') {
          set = 'state=pending&commentId=' + this.comments[i].commentId;
        } else {
          set = 'state=spammed&commentId=' + this.comments[i].commentId;
        }
        break;
      default:
        break;
    }
    if (set != '') {
      var result = await this.http.post(apiurl + 'update-comment-hbook', set, { 'headers': { 'content-type': 'application/x-www-form-urlencoded' } }).toPromise();
      if (result['result']) {
        this.comments[i] = result['data'][0];
      }
    }
    await this.spinner.hide();
  }

  async spamComment(i) {
    await this.spinner.show();
    var result = await this.http.post(apiurl + 'delete-comment-hbook', 'where=commentId=' + this.comments[i].commentId, { 'headers': { 'content-type': 'application/x-www-form-urlencoded' } }).toPromise();
    this.getCountAndComments(this.type, this.page);
  }

  edit(i) {
    this.comments[i].edit = true;
  }

  originalText
  saveOriginalText(t) {
    if (!this.originalText) {
      this.originalText = t;
    }

  }

  async save(i) {
    if (this.originalText == this.comments[i].commentContent) {
      return;
    }
    await this.spinner.show();
    // this.comments[i].edit = false;
    var sql = 'commentContent=' + this.comments[i].commentContent + '&commentId=' + this.comments[i].commentId;
    var result = await this.http.post(apiurl + 'update-comment-hbook', sql, { 'headers': { 'content-type': 'application/x-www-form-urlencoded' } }).toPromise();
    if (result['result']) {
      this.comments[i] = result['data'][0];
    }
    this.originalText = null;
    await this.spinner.hide();
  }

  async approveAll() {
    await this.spinner.show();
    for (let i in this.comments) {
      await this.updateComment(i, 'publish', true);
    }
    this.getCountAndComments(this.type, this.page)
  }

  async deleteAll() {
    await this.spinner.show();
    for (let i in this.comments) {
      await this.updateComment(i, 'delete', true);
    }
    this.getCountAndComments(this.type, this.page)
  }

  openURL(url) {
    window.open(url);
  }
}
